import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Video } from '../models/video.model';
import { Tag } from '../models/tag.model';
import { User } from '../models/user.model';
import { UsersService } from './users.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class VideosService {

  protocol = window.location.protocol

  public playAgain: Subject<void> = new Subject<void>();


  constructor(private http: HttpClient, private usersService: UsersService) { }

  getVideosByTagId(value: string, page: number) {//קבלת כל הסרטונים של תגית מסוימת
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    return this.http.get<Tag>(`api/videos/tagId/${value}?userId=${userId}&showBlocked=${showBlocked}&page=${page}`)
  }

  searchVideos(text: string, selector: string, page: number) {
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    const src = `api/videos/search?userId=${userId}&showBlocked=${showBlocked}&text=${encodeURIComponent(text)}&page=${page}`
    return this.http.get<{ videos: Video[], nextPage: number }>(src)
  }

  getVideoById(id: string) {//קבלת פרטי הסרטון לפי מזהה הסרטון
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    return this.http.get<Video>(`api/videos/open/${id}?userId=${userId}&showBlocked=${showBlocked}`)
  }

  getVideoByChannelId(channelId: string, page: number) {//get videos of a channel
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    return this.http.get<Video[]>(`api/videos/channel/${channelId}?userId=${userId}&showBlocked=${showBlocked}&page=${page}`)
  }

  getRelativeVideos(id: string, page: number) {//קבלת סרטונים דומים לסרטון מסוים
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    return this.http.get<{ relativeVideos: Video[], nextPage: number }>(`api/videos/relative-videos/${id}?userId=${userId}&showBlocked=${showBlocked}&page=${page}`)
  }

  addToFavorite(id: string) {//הוספת סרטון למועדפים
    const userId = JSON.parse(localStorage.getItem('user')).userId
    return this.http.put(`api/users/favorites/add/${userId}?videoId=${id}`, {})
  }

  removeFavorite(id: string) {//השרת הסרטון מהמועדפים
    const userId = JSON.parse(localStorage.getItem('user')).userId
    return this.http.put(`api/users/favorites/remove/${userId}?videoId=${id}`, {})
  }

  isFavorite(video_id: string, userId: number) {//האם הסרטון נמצא ברשימת המועדפים של המשתמש
    return this.http.get<boolean>(`api/users/isFavoite/${userId}?videoId=${video_id}`)
  }

  getNew(page: number) {//קבלת הסרטונים שנוספו לאחרונה
    const userId = JSON.parse(localStorage.getItem('user')).userId
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    return this.http.get<Video[]>(`api/videos/new?userId=${userId}&showBlocked=${showBlocked}&page=${page}`)
  }

  getBlockPage() {
    return this.http.get<string>('http://www.enativ.com/blockWithoutSiteRequest.html')
  }

  async addView(videoID: string) {
    const ipData = await this.getIp()
    this.usersService.sessionDetails.subscribe(d => {

      const sessionData = d
      this.http.post('api/views/add',
        {
          userId: JSON.parse(localStorage.getItem('user')).userId,
          ipAddress: ipData['ip'],
          windowsMachine: sessionData ? sessionData['WindowsMachine'] : '',
          video_id: videoID
        }).subscribe(a => {
          console.log('addView', a)
        })
    })
  }

  async getIp() {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json').toPromise()
  }

  reportVideo(videoId: string, siteId: number, meesage: string) {
    const user = JSON.parse(localStorage.getItem('user'))
    return this.http.post(`api/users/report-video?userId=${user.userId}&videoId=${videoId}&message=${meesage}&siteId=${siteId}&login=${user.login}`, {})
  }

  getOffers(text: string) {
    const user = JSON.parse(localStorage.getItem('user'))
    const showBlocked = JSON.parse(localStorage.getItem('showBlocked'))
    return this.http.get<Video[]>(`api/videos/offers?text=${text}&userId=${user.userId}&showBlocked=${showBlocked}`)
  }

  playAgain1() {
    this.playAgain.next();
  }

}